/** @file Rounds a number to a precision and clamps it into [min, max]. */
import { clamp } from '@pose2d/math/clamp';

/** Optional limits shared by every numeric control. */
export interface NumberBounds {
  min?: number;
  max?: number;
  /** Decimal places kept (0..20); omitted = no rounding. */
  precision?: number;
}

/** Rounds to `precision` decimals first, then clamps, so the result never leaves [min, max]. */
export function constrainNumber(value: number, bounds: NumberBounds): number {
  const rounded = bounds.precision === undefined ? value : Number(value.toFixed(bounds.precision));
  return clamp(rounded, bounds.min ?? -Infinity, bounds.max ?? Infinity);
}
